export const SIGNED_OUT = null
export const REQUIRE_NEW_PASSWORD = 'REQUIRE_NEW_PASSWORD'
export const AUTO_RESET_PASSWORD = 'AUTO_RESET_PASSWORD'
export const SIGN_UP = 'SIGN_UP'
export const CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP'
export const SIGNED_IN = 'SIGNED_IN'
